import React from 'react';

import Pagination from '@grupa-pracuj/react-pagination';

import ChevronRight from '@mdi/svg/svg/chevron-right.svg';

import 'src/components/Pagination/NextButton.scss';


const NextButton = () => (
  <Pagination.NextButton render={ ({ scrollNext }) => (
    <div styleName="next">
      <button
        aria-label="Następne"
        data-test="button-moveRight"
        onClick={ scrollNext }
        styleName="next__button"
        type="button"
      >
        <ChevronRight viewBox="0 0 24 24" />
      </button>
    </div>
  ) }
  />
);


export default NextButton;
